/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WaitlistPromoteResponse
 */
export interface WaitlistPromoteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof WaitlistPromoteResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof WaitlistPromoteResponse
     */
    promotedTeamId?: string;
    /**
     * 
     * @type {string}
     * @memberof WaitlistPromoteResponse
     */
    message: string;
}

/**
 * Check if a given object implements the WaitlistPromoteResponse interface.
 */
export function instanceOfWaitlistPromoteResponse(value: object): value is WaitlistPromoteResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function WaitlistPromoteResponseFromJSON(json: any): WaitlistPromoteResponse {
    return WaitlistPromoteResponseFromJSONTyped(json, false);
}

export function WaitlistPromoteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WaitlistPromoteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'promotedTeamId': json['promotedTeamId'] == null ? undefined : json['promotedTeamId'],
        'message': json['message'],
    };
}

export function WaitlistPromoteResponseToJSON(json: any): WaitlistPromoteResponse {
    return WaitlistPromoteResponseToJSONTyped(json, false);
}

export function WaitlistPromoteResponseToJSONTyped(value?: WaitlistPromoteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'promotedTeamId': value['promotedTeamId'],
        'message': value['message'],
    };
}

